export default {
    surveyBuilder: {
        farmName: "Farm",
        farmerName: "Farmer Name",
        scores: "Scores",
        clearSelection: "Clear All Users",
        addNewSurvey: "Add New Survey",
        surveyTitle: "Survey Title",
        surveyName: "Survey Name",
        surveyDescription: "Survey Description",
        describeSurvey: "Describe the Survey",
        enableScheduling: "Enable Scheduling",
        enableSchedulingInfo: "Ability to set a specific date or time for the assessment.",
        selectedDate: "Selected Date",
        multiStepSurvey: "Multi-Step Survey",
        multiStepSurveyDetails:
          "Based on the number of questions in a step, all questions in the survey will be grouped and displayed in steps.",
        multiStep: "Multi Step",
        noQuestionEachStep: "Number of questions in each step",
        surveyStatus: "Survey Status",
        surveyStatusDetails:
          "Survey can be enabled only after adding questions. Enabling a survey will allow farmers to start submissions.",
        selectUsers: "Select Users",
        selectUsersDetails:
          "If select user is disabled then the survey will be available to all the users. If you Enable selected users you can select multiple users in the next step.",
        linkWithFarms: "Link With Farms",
        linkWithFarmsDetails:
          "If enabled the survey will be linked with individual farms. If a Farmer has multiple farms then each farm will have its own survey.",
        enabled: "Enabled",
        disabled: "Disabled",
        cancel: "Cancel",
        next: "Next",
        surveySettings: "Survey Settings",
    
        selectSurveyUsers: "Select Survey Users",
        selectToProceed: "Please select user(s) to proceed",
        searchUsers: "Search Users",
        usersSelected: "Users Selected",
        conditional: "Conditional",
        autoConditional: "Auto Conditional",
        userName: "User Name",
        email: "Email",
        membershipType: "Membership Type",
        membershipValidity: "Membership Validity",
        membershipRemainingDays: "Number of Days Remaining",
        membershipRole: "Member Role",
        accountProgress: "Account Progress",
        status: "Status",
        active: "Active",
        deactivated: "Deactivated",
        continue: "Continue",
        organization: "Organization",
        migrateSurvey: "Migrate Survey",
        migrateAlreadyDone: "Already migrated",
        migrateAlreadyDoneInfo: "This survey is already in the new ESG collections. Re-migrating would overwrite it with the current legacy data, so only a dry run is available.",
        migrateSurveyInfo: "Copies this legacy survey - its questions, options and submitted responses - into the new ESG survey collections. Safe to run again: existing documents are updated, never duplicated.",
        migrateModeDryRun: "Dry run (writes nothing)",
        migrateModeMigrate: "Migrate for real",
        migrateRun: "Run",
        migrateViewFullReport: "View full report",
        migrateHideFullReport: "Hide full report",
        migrateFailed: "Migration request failed",
        migrateSurveys: "Migrate Surveys",
        migrateSelected: "Migrate Selected ({count})",
        migrateSelectedCount: "{count} surveys selected",
        migrateClearSelection: "Clear",
        migrateSelectAll: "Select all on this page",
        migrateDetails: "Details",
        migrateProgressLabel: "{done} of {total} done ({percent}%)",
        migrateCurrentLabel: "Running: {title}",
        migrateStop: "Stop",
        migrateStopped: "stopped after {done} of {total}",
        migrateStatusMigrated: "Migrated",
        migrateStatusOk: "Completed",
        migrateStatusNotEligible: "Not migrated",
        migrateStatusAlreadyMigrated: "Already migrated",
        migrateStatusFailed: "Failed",
        migrateStatusNotFound: "Not found",
        migrateColQuestions: "questions",
        migrateColOptions: "options",
        migrateColAnswers: "answers",
        migrateColUsers: "users created",
        migrateColSkipped: "skipped records",
        migrateColNothing: "nothing to write",
        questions: "Questions",
        questionInfo: "The text of the assessment question that will be presented to the respondent.",
        responses: "Responses",
        deleteSurvey: "Delete Survey",
        editSurvey: "Edit Survey",
        type: "Type",
        typeInfo: "A dropdown menu to specify the type of input required for the question, such as radio button, checkbox, or text input.",
        compulsory: "Compulsory",
        createSurvey: "Create Survey",
        surveyBuilder: "Survey Builder",
        surveyList: "Survey List",
        farm: "Farm",
        responseDate: "Response Date",
        viewSurvey: "View Survey",
        question: "Question",
        settings: "Settings",
        addQuestion: "Add Question",
        surveysSubmitted: "Surveys Submitted",
        surveyDetail: "Survey Detail",
        conditionStatus: "Condition Status",
        conditionStatusDesc:
          "Users matching the conditions will become eligible for the survey automatically. ",
    
        endSurvey: "End Survey",
        publishSurvey: "Publish Survey",
        copy: "Copy",
        view: "View",
        startDate: "Start Date",
        endDate: "End Date",
        chooseDate: "Choose date",
        select: "Select",
        addSurveyQuestion: "Add Survey Question",
        editSurveyQuestion: "Edit Survey Question",
        questionScore: "Question Score",
        mandatory: "Mandatory",
        yes: "Yes",
        no: "No",
        options: "Options",
        typeHere: "Type here",
        add: "Add",
        optionsHint: "Please enter to add an answer or click on Add",
        surveyProgress: "Survey in progress",
        allResponses: "All responses summary",
        responseQuestion: "Responses by question",
        dateSubmitted: "Date Submitted",
        answer: "Answers",
        totalScore: "Total Score",
        score: "Score",
        singleSelection: "Single Selection",
        multipleSelection: "Multiple Selection",
        if: "If",
        then: "then",
        noResponse: "No response",
        noSurveyFound: "No Surveys Found",
        createNewSurvey:
          'Please create survey using the button "Create Survey" above',
        cannotPublish: "Cannot publish a disabled survey!",
        deleteSurveyWarn:
          "Are you sure you want to delete the survey. If you delete it all survey questions and submissions will be deleted permanently.",
        noQuestionFound: "No Questions Found",
        createQuestion:
          'Please add question first using the button "ADD QUESTIONS" above',
        deleteQuestion: "Are you sure you want to delete the question?",
        applyChanges: "How would you like to apply these changes?",
        editFutureSurveys: "EDIT FUTURE SURVEYS ONLY",
        editLiveSurveyOnly: "EDIT LIVE SURVEY ONLY",
        surveyIsLive:
          "Please note that the survey is currently live, and editing a question at this time may impact previous submissions. To avoid any issues, you may consider creating a copy of the survey in order to make changes to the questions.",
        clickToCopy: "Click Here To Create Survey Copy",
        applyChangesNow: "APPLY CHANGES NOW",
        copySurvey: "Copy Survey",
        changeCopySurveyName:
          "You can change the name of the copied survey version.",
    
        textField: "Text Field",
        textArea: "Text Area",
        textFieldNumeric: "Text Field Numeric",
        radioButton: "Radio Button",
        checkBoxes: "Check Boxes",
        fileAttachment: "File Attachment",
        digitalSignature: "Digital Signature",
        gpsLocation: "GPS Location",
        dynamicFarmer: "Dynamic Farmer",
        dynamicGeofence: "Dynamic Geofence",
        dynamicCrop: "Dynamic Crop",
        dynamicEquipment: "Dynamic Equipments",
        downloadSurvey: "Download Survey",
        downloadQuestion: "Download Only Questions",
        downloadResponse: "Download All Responses",
        chooseFileFormat: "Choose File Format",
        surveyTitleLength: "Survey title should be less than 100 character",
        selectAllFiltered: "Select all filtered",
        surveyDownloads: "Survey Download's",

        // Admin "view responses" screens
        surveyResponsesTitle: "Survey Responses",
        viewResponses: "View Responses",
        allResponsesSummary: "All Responses Summary",
        responsesByQuestion: "Responses By Question",
        selectQuestion: "Select a question",
        noSubmissions: "No responses submitted yet",
        notAnswered: "Not answered",
        repeatSubmissions: "Repeat submissions",
        rejectionReason: "Rejection reason",
        submittedDate: "Submitted Date",
        farmColumn: "Farm",
        farmerNameColumn: "Farmer Name",
        totalFarms: "Total Farms",
        answeredByFarmsIndividually: "This question is answered by farms individually.",
        singleResponsePerFarmer: "This question has a single response for each farmer.",
        dataType: "Data Type",
        measurementUnit: "Measurement Unit",
        dimitraModule: "Dimitra Module",
        users: "Users",

        // Consumer survey flow (list / questions / answer)
        surveys: "Surveys",
        answerTitle: "Answer",
        searchAssessments: "Search assessments...",
        description: "Description",
        audience: "Audience",
        actions: "Actions",
        loadingSurveys: "Loading surveys...",
        noSurveysAssigned: "No surveys assigned.",
        failedToLoadSurveys: "Failed to load surveys. Please try again.",
        actionPlanIdMissing: "Action plan ID is missing",
        filesUploadedSuccess: "Files uploaded successfully",
        filesUploadFailed: "Failed to upload files",
        fileUploadFailedNamed: "Failed to upload {name}",
        fileRemovedSuccess: "File removed successfully",
        submissionWindowClosed: "Submission is only allowed for the current active window.",
        unsupportedQuestionType: "Unsupported question type: {type}",
        responseDataCreateFailed: "Failed to create response data",
      },
}